import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Select
 */
import { Emitter } from '@tencent/glue-util-emitter';
import { OptionState } from '../enums';
export var SelectAllEnum;

(function (SelectAllEnum) {
  SelectAllEnum["ALL"] = "__all__";
})(SelectAllEnum || (SelectAllEnum = {}));

export var Select = /*#__PURE__*/function (_Emitter) {
  _inherits(Select, _Emitter);

  var _super = _createSuper(Select);

  function Select(options) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this);
    _this.multiple = false;
    _this.disabled = false;
    _this.readonly = false;
    _this.searchQuery = '';
    _this.optionMap = {};
    _this.optionIdSort = [];
    _this.groupMap = {};
    _this.value = [];
    _this.backFillId = '';
    _this.selectAllDisabled = false;
    _this.selectAllReadonly = false;
    _this.selectAll = false;
    _this.showAll = false;
    _this.showOptionsIdSort = []; // 加载数据源函数

    _this.filterOption = function (query, data) {
      return _this.defaultQuery(query, data);
    };

    _this.updateSelectOptions(options);

    return _this;
  }

  _createClass(Select, [{
    key: "dispose",
    value: function dispose() {
      var _this2 = this;

      Object.keys(this.optionMap).forEach(function (id) {
        _this2.optionMap[id].dispose();
      });
      Object.keys(this.groupMap).forEach(function (id) {
        _this2.groupMap[id].dispose();
      });
      this.optionMap = {};
      this.groupMap = {};
    }
  }, {
    key: "updateSelectOptions",
    value: function updateSelectOptions(options) {
      var _options$filterOption = options.filterOption,
          filterOption = _options$filterOption === void 0 ? this.defaultQuery : _options$filterOption,
          _options$multiple = options.multiple,
          multiple = _options$multiple === void 0 ? false : _options$multiple,
          _options$disabled = options.disabled,
          disabled = _options$disabled === void 0 ? false : _options$disabled,
          _options$readonly = options.readonly,
          readonly = _options$readonly === void 0 ? false : _options$readonly,
          value = options.value,
          _options$showAll = options.showAll,
          showAll = _options$showAll === void 0 ? false : _options$showAll,
          extraProps = options.extraProps;
      var needUpdateOptionData = this.value !== value || this.disabled !== disabled || this.readonly !== readonly;
      this.filterOption = filterOption;
      this.multiple = multiple;
      this.value = value;
      this.disabled = disabled;
      this.readonly = readonly;
      this.extraProps = extraProps;

      if (needUpdateOptionData) {
        this.updateOptionData();
      }

      if (this.showAll !== showAll) {
        this.showAll = showAll;

        if (!this.searchQuery && showAll) {
          this.showOptionsIdSort.unshift(SelectAllEnum.ALL);
        } else if (!showAll && this.showOptionsIdSort[0] === SelectAllEnum.ALL) {
          this.showOptionsIdSort.shift();
        }
      }

      var newDisabled = this.isSelectAllDisabled();
      var newReadonly = this.isSelectAllReadonly();
      var newSelectAll = this.isSelectAll();
      var needUpdateSelectAll = this.selectAllDisabled !== newDisabled || this.selectAllReadonly !== newReadonly || this.selectAll !== newSelectAll;
      this.selectAllDisabled = newDisabled;
      this.selectAllReadonly = newReadonly;
      this.selectAll = newSelectAll;

      if (needUpdateSelectAll) {
        this.emit('update-select-all-state');
      }
    }
  }, {
    key: "updateOptionIdSort",
    value: function updateOptionIdSort(ids) {
      if (this.optionIdSort.join(',') === ids.join(',')) {
        return;
      }

      this.optionIdSort = ids;
      this.showOptionsIdSort = this.optionIdSort.slice(0);

      if (this.showAll) {
        this.showOptionsIdSort.unshift(SelectAllEnum.ALL);
      }
    }
  }, {
    key: "stepUp",
    value: function stepUp() {
      var len = this.showOptionsIdSort.length;

      if (!len) {
        this.backFillId = '';
        this.emit('back-fill-update', this.backFillId);
        return;
      }

      var idx = this.showOptionsIdSort.indexOf(this.backFillId || '');

      if (idx < 0) {
        this.backFillId = this.showOptionsIdSort[0];
      } else {
        this.backFillId = this.showOptionsIdSort[(idx + len - 1) % len];
      }

      this.emit('back-fill-update', this.backFillId);
    }
  }, {
    key: "stepDown",
    value: function stepDown() {
      var len = this.showOptionsIdSort.length;

      if (!len) {
        this.backFillId = '';
        return;
      }

      var idx = this.showOptionsIdSort.indexOf(this.backFillId || '');

      if (idx < 0) {
        this.backFillId = this.showOptionsIdSort[0] || '';
      } else {
        this.backFillId = this.showOptionsIdSort[(idx + len + 1) % len];
      }

      this.emit('back-fill-update', this.backFillId);
    }
  }, {
    key: "selectBackFill",
    value: function selectBackFill() {
      if (!this.backFillId) {
        return;
      }

      if (this.backFillId === SelectAllEnum.ALL) {
        this.setSelectAll(this.selectAll ? OptionState.UNSELECTED : OptionState.SELECTED);
        return;
      }

      var option = this.optionMap[this.backFillId];

      var _option$getData = option.getData(),
          selected = _option$getData.selected;

      option.setOptionState(selected ? OptionState.UNSELECTED : OptionState.SELECTED);
    }
  }, {
    key: "registerOption",
    value: function registerOption(option) {
      var id = option.getId();

      if (this.optionMap[id]) {
        console.error(new Error("id=".concat(id, " option component has been registered")));
      }

      this.optionMap[id] = option;
      this.emit('select-option-update');
    }
  }, {
    key: "unregisterOption",
    value: function unregisterOption(option) {
      var id = option.getId();

      if (!this.optionMap[id]) {
        console.error(new Error("id=".concat(id, " option component does not been registered")));
      }

      delete this.optionMap[id];
      this.emit('select-option-update');
    }
  }, {
    key: "registerOptionGroup",
    value: function registerOptionGroup(optionGroup) {
      var id = optionGroup.getId();

      if (this.optionMap[id]) {
        console.error(new Error("id=".concat(id, " optionGroup component has been registered")));
      }

      this.groupMap[id] = optionGroup;
    }
  }, {
    key: "unregisterOptionGroup",
    value: function unregisterOptionGroup(optionGroup) {
      var id = optionGroup.getId();

      if (!this.groupMap[id]) {
        console.error(new Error("id=".concat(id, " optionGroup component dose not been registered")));
      }

      delete this.groupMap[id];
    }
  }, {
    key: "setQuery",
    value: function setQuery(query) {
      this.searchQuery = query;
      this.emit('query-change', this.searchQuery);
      this.emit('search-query', this.querySearch());
    }
  }, {
    key: "setSelect",
    value: function setSelect(optionId, state) {
      var option = this.optionMap[optionId];
      var optionValue = option.getData().value;
      var value = this.value.slice(0);
      var idx = value.indexOf(optionValue);

      if (state === OptionState.UNSELECTED) {
        // 当前就是未选中 或者是 单选，不能取消选中
        if (idx < 0 || !this.multiple) {
          return;
        }

        value.splice(idx, 1);
        this.emit('value-change', value, this.getDisplayInfo(value));
        return;
      }

      if (state === OptionState.SELECTED) {
        if (idx >= 0) {
          return;
        }

        if (this.multiple) {
          value.push(optionValue);
        } else {
          value = [optionValue];
        }

        this.emit('value-change', value, this.getDisplayInfo(value));
      }
    }
  }, {
    key: "trySetSelect",
    value: function trySetSelect(optionId, state) {
      this.emit('try-set-state', optionId, state);
    }
  }, {
    key: "setSelectAll",
    value: function setSelectAll(state) {
      var _this3 = this;

      if (!this.multiple) {
        return;
      }

      if (state === OptionState.UNSELECTED) {
        this.emit('value-change', [], []);
      } else {
        var value = this.optionIdSort.map(function (id) {
          var _this3$optionMap$id$g = _this3.optionMap[id].getData(),
              value = _this3$optionMap$id$g.value,
              disabled = _this3$optionMap$id$g.disabled;

          return disabled ? null : value;
        }).filter(function (value) {
          return value != null;
        });
        this.emit('value-change', value, this.getDisplayInfo(value));
      }
    }
  }, {
    key: "resetValue",
    value: function resetValue() {
      this.emit('value-change', [], []);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.disabled;
    }
  }, {
    key: "isReadonly",
    value: function isReadonly() {
      return this.readonly;
    }
  }, {
    key: "isSelected",
    value: function isSelected(value) {
      return this.value.indexOf(value) >= 0;
    }
  }, {
    key: "getShowOptionsIdSort",
    value: function getShowOptionsIdSort() {
      return this.showOptionsIdSort;
    }
  }, {
    key: "getSelectAllDisabled",
    value: function getSelectAllDisabled() {
      return this.selectAllDisabled;
    }
  }, {
    key: "getSelectAllReadonly",
    value: function getSelectAllReadonly() {
      return this.selectAllReadonly;
    }
  }, {
    key: "getSelectAll",
    value: function getSelectAll() {
      return this.selectAll;
    }
  }, {
    key: "getExtraProps",
    value: function getExtraProps() {
      return this.extraProps;
    }
  }, {
    key: "getOption",
    value: function getOption(id) {
      return this.optionMap[id];
    }
  }, {
    key: "getDisplayInfo",
    value: function getDisplayInfo(value) {
      var _this4 = this;

      var innerValue = value || this.value;
      var info = [];
      Object.keys(this.optionMap).forEach(function (id) {
        var option = _this4.optionMap[id];
        var data = option.getData();

        if (innerValue.indexOf(data.value) >= 0) {
          info.push({
            label: data.label,
            value: data.value,
            disabled: data.disabled,
            readonly: data.readonly,
            id: id
          });
        }
      });
      return info;
    }
  }, {
    key: "updateOptionData",
    value: function updateOptionData() {
      var _this5 = this;

      Object.keys(this.optionMap).forEach(function (id) {
        var option = _this5.optionMap[id];
        var data = option.getData();
        var value = data.value;
        var disabled = data.disabled || _this5.disabled;
        var readonly = data.readonly || _this5.readonly;
        var selected = _this5.value.indexOf(value) >= 0;
        var needOptionUpdate = false;

        if (disabled !== data.disabled) {
          data.disabled = disabled;
          needOptionUpdate = true;
        }

        if (readonly !== data.readonly) {
          data.readonly = readonly;
          needOptionUpdate = true;
        }

        if (selected !== data.selected) {
          option.updateSelected(selected);
          return;
        }

        if (needOptionUpdate) {
          option.stateUpdated();
        }
      });
    }
  }, {
    key: "defaultQuery",
    value: function defaultQuery(query, optionData) {
      var label = optionData.label;

      if (!this.searchQuery) {
        return true;
      }

      return label.indexOf(this.searchQuery) >= 0;
    }
  }, {
    key: "querySearch",
    value: function querySearch() {
      var _this6 = this;

      var res = {};
      Object.keys(this.optionMap).forEach(function (id) {
        var option = _this6.optionMap[id];
        var data = option.getData();
        var ids = option.getOptionIdPath();
        ids.pop();

        if (!_this6.filterOption(_this6.searchQuery, data)) {
          return;
        }

        res[id] = _objectSpread(_objectSpread({}, data), {}, {
          type: 'option'
        });

        if (!ids.length) {
          return;
        }

        ids.forEach(function (groupId) {
          if (res[groupId]) {
            return;
          }

          var group = _this6.groupMap[groupId];
          res[groupId] = {
            type: 'group',
            title: group.getTitle()
          };
        });
      });

      if (Object.keys(res).length) {
        res[SelectAllEnum.ALL] = {
          type: 'all'
        };
      }

      this.calcShowOptionsIdSort(res);
      return res;
    }
  }, {
    key: "calcShowOptionsIdSort",
    value: function calcShowOptionsIdSort(data) {
      var newIdSort = [];
      this.optionIdSort.forEach(function (id) {
        if (data[id]) {
          newIdSort.push(id);
        }
      });

      if (this.showAll && !this.searchQuery) {
        newIdSort.unshift(SelectAllEnum.ALL);
      }

      this.showOptionsIdSort = newIdSort;
    }
  }, {
    key: "isSelectAllDisabled",
    value: function isSelectAllDisabled() {
      var _this7 = this;

      var optLen = Object.keys(this.optionMap).length;
      return !!optLen && Object.keys(this.optionMap).every(function (id) {
        return _this7.optionMap[id].getData().disabled;
      });
    }
  }, {
    key: "isSelectAllReadonly",
    value: function isSelectAllReadonly() {
      var _this8 = this;

      var optLen = Object.keys(this.optionMap).length;
      return !!optLen && Object.keys(this.optionMap).every(function (id) {
        return _this8.optionMap[id].getData().readonly;
      });
    }
  }, {
    key: "isSelectAll",
    value: function isSelectAll() {
      var _this9 = this;

      var optLen = Object.keys(this.optionMap).length;

      if (!optLen) {
        return false;
      }

      return Object.keys(this.optionMap).filter(function (id) {
        return !_this9.optionMap[id].getData().disabled;
      }).every(function (id) {
        return _this9.optionMap[id].getData().selected;
      });
    }
  }]);

  return Select;
}(Emitter);